<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :expandedOptions="{
                enabled: true,
                template: 'credit-card-charge-logs',
            }"
        ></dx-grid>

        <v-dialog persistent v-model="importDialog" max-width="450">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Import Charges</v-card-title
                >
                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload File
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn></v-layout
                >
                <div class="dropArea" ref="dropArea" v-if="!files.length">
                    Drag and drop a file here
                </div>
                <div v-if="files.length" class="pt-2 mt-0 ml-2">
                    {{ files[0].name }}
                </div>
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".xlsx, .xls"
                    @change="onFilePicked($event)"
                />
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeImportDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="importFile()"
                    >
                        import
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="creditCardUsersDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Credit Card Users</v-card-title
                >

                <v-layout row class="ml-3">
                    <v-btn
                        small
                        color="success"
                        class="mb-3"
                        @click="openAddCreditCardUser"
                        >Add User</v-btn
                    >
                    <v-btn
                        small
                        color="success"
                        class="mb-3 ml-2"
                        v-if="creditCardUsers.some((l) => l.selected)"
                        @click="openDeleteCreditCardUsers"
                        :loading="processing"
                        >Delete Users</v-btn
                    >
                </v-layout>

                <!-- <div v-for="(user, index) in creditCardUsers">
                    <v-layout row class="pa-0 ml-3 mb-0">
                        <v-text-field
                            class="width-150 mr-2 pt-3"
                            v-model="user.firstName"
                            label="First Name"
                            :rules="[rules.required]"
                            ref="firstName"
                        ></v-text-field>
                        <v-text-field
                            class="width-200 pt-3 mr-2"
                            v-model="user.lastName"
                            label="Last Name"
                            :rules="[rules.required]"
                            ref="lastName"
                        ></v-text-field>
                        <v-autocomplete
                        class="my-2"
                        hide-details
                        label="Assigned To"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="username"
                        v-model="user.username"
                        :items="users"
                        :search-input.sync="loadUsers"
                    ></v-autocomplete>
                    </v-layout>
                </div>
                <v-btn
                    color="success"
                    small
                    class="ml-3 mt-0 mb-4"
                    :loading="processing"
                    @click="saveNewAllowedNumbers"
                    v-if="newAllowListNumbers.length"
                    >Save</v-btn
                > -->

                <v-layout row class="pa-0 mb-2 ml-3 font-weight-medium">
                    <div class="width-50"></div>
                    <div class="width-150">First Name</div>
                    <div class="width-200">Last Name</div>
                    <div class="width-200">User Name</div>
                </v-layout>
                <v-divider class="pb-0 pt-2"></v-divider>
                <div style="height: 450px; overflow-y: auto;">
                    <div v-for="(user, index) in creditCardUsers">
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-if="!user.editing"
                        >
                            <v-checkbox
                                class="width-50 my-0 pt-2"
                                hide-details
                                v-model="user.selected"
                                color="success"
                            ></v-checkbox>

                            <div class="width-150 pt-2">
                                {{ user.firstName }}
                            </div>
                            <div class="width-200 pt-2">
                                {{ user.lastName }}
                            </div>
                            <div class="width-200 pt-2">
                                {{ user.username }}
                            </div>
                            <v-btn
                                @click="editUser(user)"
                                :disabled="disableEditing()"
                                flat
                                icon
                                class="my-0 pb-1"
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-if="user.editing"
                        >
                            <v-text-field
                                class="width-150 mr-2 pt-3"
                                v-model="user.firstName"
                                label="First Name"
                                :rules="[rules.required]"
                                ref="firstName"
                            ></v-text-field>
                            <v-text-field
                                class="width-200 pt-3 mr-2"
                                v-model="user.lastName"
                                label="Last Name"
                                :rules="[rules.required]"
                                ref="lastName"
                            ></v-text-field>
                            <v-autocomplete
                                class="my-2"
                                hide-details
                                label="Assigned To"
                                placeholder="Start typing..."
                                hide-no-data
                                ref="username"
                                v-model="user.usernameCopy"
                                :items="users"
                                :rules="[rules.required]"
                                multiple
                            ></v-autocomplete>
                            <v-btn
                                class="ml-2 mt-3"
                                color="default"
                                small
                                dark
                                style="height: 28px;"
                                @click="rollbackUser(user)"
                                >Cancel</v-btn
                            >
                            <v-btn
                                small
                                class="ml-2 mt-3"
                                color="success"
                                style="height: 28px;"
                                :loading="processing"
                                @click="saveUser(user)"
                                >Save</v-btn
                            >
                        </v-layout>
                        <v-divider
                            class="pb-0 pt-2"
                            v-if="index + 1 < creditCardUsers.length"
                        ></v-divider>
                    </div>
                </div>

                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="creditCardUsersDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="deleteCreditCardUsersDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Credit Card Users</v-card-title
                >

                <div class="font-weight-medium">
                    This will delete the
                    {{ creditCardUsers.filter((c) => c.selected).length }}
                    selected users
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteCreditCardUsersDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteUsers()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addCreditCardUserDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2"
                    >Add Credit Card User</v-card-title
                >

                <v-select
                    :items="unassignedUsers"
                    label="Unassigned User"
                    v-model="newCreditCardUser.unassignedUser"
                    @change="onUserSelected"
                ></v-select>
                <v-text-field
                    disabled
                    class=""
                    v-model="newCreditCardUser.firstName"
                    label="First Name"
                    :rules="[rules.required]"
                    ref="newFirstName"
                ></v-text-field>
                <v-text-field
                    disabled
                    class=""
                    v-model="newCreditCardUser.lastName"
                    label="Last Name"
                    :rules="[rules.required]"
                    ref="newLastName"
                ></v-text-field>
                <v-autocomplete
                    class=""
                    hide-details
                    label="Assigned To"
                    placeholder="Start typing..."
                    hide-no-data
                    ref="newUsername"
                    v-model="newCreditCardUser.username"
                    :items="users"
                    :rules="[rules.required]"
                    :search-input.sync="loadUsers"
                    multiple
                ></v-autocomplete>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addCreditCardUserDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewUser()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="deleteCreditCardChargesDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Credit Card Charges</v-card-title
                >

                <div class="font-weight-medium" v-if="selectedCharges.length">
                    This will delete the
                    {{ selectedCharges.length }}
                    selected credit card charges
                </div>

                <div class="font-weight-medium" v-if="!selectedCharges.length">
                    Please select credit card charges that are missing
                    description
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteCreditCardChargesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        v-if="selectedCharges.length"
                        :loading="processing"
                        color="success"
                        @click="deleteCharges()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="mapToUsersDialog" max-width="1200">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-3"
                    >Map Charges To Users</v-card-title
                >

                <v-layout row class="pa-0 mb-2 font-weight-medium">
                    <div class="width-150">Date</div>
                    <div class="width-200">Merchant</div>
                    <div class="width-100">Amount</div>
                    <div class="width-100">Card</div>
                    <div class="width-200">First Name</div>
                    <div class="width-200">Last Name</div>
                    <div class="width-200">User Name</div>
                </v-layout>
                <v-divider class="pb-0 pt-2"></v-divider>
                <div style="height: 450px; overflow-y: auto;">
                    <div v-for="(charge, index) in chargesToMap">
                        <v-layout row class="pa-0 mb-0">
                            <div class="width-150 pt-2">
                                {{ charge.transactionDate | date }}
                            </div>
                            <div class="width-200 pt-2">
                                {{ truncateText(charge.merchantName) }}
                            </div>
                            <div class="width-100 pt-2">
                                {{ charge.originalGrossAmount }}
                            </div>
                            <div class="width-100 pt-2">
                                {{ charge.cardNumber }}
                            </div>
                            <div class="width-200 pt-2">
                                {{ charge.firstName }}
                            </div>
                            <div class="width-200 pt-2">
                                {{ charge.lastName }}
                            </div>
                            <div
                                class="width-200 pt-2"
                                v-bind:class="{
                                    'text-danger': !charge.username,
                                }"
                            >
                                {{
                                    charge.username
                                        ? charge.username
                                        : "NOT FOUND"
                                }}
                            </div>
                        </v-layout>
                        <v-divider
                            class="mt-2"
                            v-if="index + 1 < chargesToMap.length"
                        ></v-divider>
                    </div>
                </div>

                <v-card-actions class="mr-0 mt-3 pb-1">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="mapToUsersDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="mapUsers()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="creditCardChargeUpdateDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2"
                    >Update Credit Card Charge</v-card-title
                >

                <div class="px-0 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Date:</div>
                        <div>{{ rowClicked.transactionDate | date }}</div>
                    </v-layout>

                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Merchant Name:
                        </div>
                        <div>
                            {{ rowClicked.merchantName }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Amount:
                        </div>
                        <div>
                            {{ rowClicked.billingGrossAmount }}
                        </div> </v-layout
                    ><v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Card Number:
                        </div>
                        <div>{{ rowClicked.cardNumber }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            First Name:
                        </div>
                        <div>{{ rowClicked.firstName }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Last Name:
                        </div>
                        <div>{{ rowClicked.lastName }}</div> </v-layout
                    ><v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            User:
                        </div>
                        <div>{{ rowClicked.username }}</div>
                    </v-layout>
                </div>

                <v-text-field
                    class=""
                    v-model="rowClicked.userDescription"
                    label="Charge Descrption"
                    ref="userDescription"
                ></v-text-field>

                <v-divider></v-divider>

                <div class="dropArea mt-3" ref="attachmentDropArea">
                    Drag and drop a file here
                </div>
                <v-layout
                    v-if="rowClicked.attachments"
                    row
                    class="mb-1 pl-0"
                    v-bind:class="{
                        'pt-1': !rowClicked.attachments.length,
                    }"
                >
                    <!-- <div class="subheading font-weight-light mt-2 pt-2 mb-1">
                        {{ getAttachmentText() }}
                    </div> -->
                    <v-btn
                        small
                        class="ml-0"
                        color="success"
                        @click="pickAttachmentFile"
                        v-if="!attachmentFiles.length"
                        >Upload Attachment</v-btn
                    >
                    <input
                        type="file"
                        style="display: none"
                        ref="attachmentFiles"
                        @change="onAttachmentFilePicked($event)"
                /></v-layout>
                <div
                    style="border: 1px solid #4caf50; border-radius: 5px;"
                    class="pa-2 my-3"
                    v-for="attachment in attachmentFiles"
                >
                    <v-layout row justify-space-between>
                        <div class="mt-0 ml-0 pt-1">
                            {{ truncateText(attachmentFiles[0].name, 27) }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="processing"
                            color="success"
                            class="my-0 mr-1"
                            small
                            outline
                            @click.stop="cancelAttachment(attachment)"
                        >
                            remove
                        </v-btn>
                        <!-- <v-btn
                            :loading="processing"
                            color="success"
                            class="my-0"
                            small
                            outline
                            @click.stop="saveFile()"
                        >
                            save
                        </v-btn> -->
                    </v-layout>
                </div>

                <div
                    style="overflow-y: auto; max-height: 150px;"
                    v-if="rowClicked.attachments"
                    class="mt-0"
                >
                    <div
                        v-for="attachment in rowClicked.attachments"
                        class="pt-0 mb-3"
                    >
                        <v-btn
                            class="my-0 ml-1 px-3"
                            @click="downloadAttachment(attachment)"
                            style="text-transform: unset;"
                        >
                            <v-icon color="blue" left dark>mdi-file</v-icon>
                            {{ truncateText(attachment.fileName) }}
                            <v-icon right>mdi-download</v-icon>

                            <v-icon
                                right
                                class="ml-3"
                                @click.stop="openDeleteAttachment(attachment)"
                                >mdi-close</v-icon
                            >
                        </v-btn>
                    </div>
                </div>

                <v-card-actions class="mr-0 mt-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUpdateChargeDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveCharge()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="uploadAttachmentDialog" persistent max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pb-2 pl-0 pt-0"
                    >Upload Attachment</v-card-title
                >
                <v-btn
                    small
                    outline
                    color="success"
                    :loading="uploading"
                    @click="pickAttachmentFile()"
                    >Upload</v-btn
                >
                <div
                    class="dropArea"
                    ref="attachmentDropArea"
                    v-if="!attachmentFiles.length"
                >
                    Drag and drop a file here
                </div>
                <div v-if="attachmentFiles.length" class="mt-0">
                    {{ attachmentFiles[0].name }}
                </div>
                <input
                    type="file"
                    style="display: none"
                    ref="attachmentFiles"
                    @change="onAttachmentFilePicked($event, false)"
                />

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadAttachmentDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveFile()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <v-dialog persistent v-model="deleteAttachmentDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Attachment</v-card-title
                >

                <div class="font-weight-medium">
                    This will delete the Attachment:
                    {{ attachmentToDelete.fileName }}
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteAttachmentDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteAttachment()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import JsZip from "jszip";
import moment from "moment";
import { truncate, pluralize } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Credit Card Charges",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",
        processing: false,
        uploading: false,
        importDialog: false,
        doeData: {},
        files: [],
        attachmentFiles: [],
        requestID: "",
        importSource: "",
        sources: [],

        selected: [],
        deleteCreditCardChargesDialog: false,
        statusUpdaterDialog: false,
        updateDialog: false,
        rowClicked: {
            attachments: [],
        },
        status: "",

        creditCardChargeUpdateDialog: false,

        addRegFormDialog: false,
        clickedRegForm: {},

        creditCardUsersDialog: false,
        creditCardUsers: [],
        processing: false,
        unassignedUsers: [],
        editingDescrption: false,

        addCreditCardUserDialog: false,
        uploadAttachmentDialog: false,

        newCreditCardUser: {
            firstName: "",
            lastName: "",
            username: "",
            unassignedUser: "",
        },

        mapToUsersDialog: false,
        chargesToMap: [],
        selectedCharges: [],

        deleteCreditCardUsersDialog: false,

        users: [],
        loadUsers: null,

        uploadUrl: "",

        attachmentToDelete: {},
        deleteAttachmentDialog: false,

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                },
                icon: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "mdi-check-circle";
                        case "MISSING DESCRIPTION":
                            return "mdi-alert";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "success";
                        case "MISSING DESCRIPTION":
                            return "#f35123";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                field: "id",
                label: "ID",
                link: "CreditCardChargeView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Reference",
                field: "transactionReference",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Date",
                field: "transactionDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "fullName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "firstName",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Merchant Name",
                field: "merchantName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Billing Gross Amount",
                field: "billingGrossAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Original Gross Amount",
                field: "originalGrossAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Original Net Amount",
                field: "transactionOriginalNetAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Tax Amount",
                field: "transactionTaxAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Month",
                field: "month",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Number",
                field: "cardNumber",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "User",
                field: "username",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Charge Description",
                field: "userDescription",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Attachment",
                field: "attachmentFileName",
                format: "",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Entered By",
                field: "enteredBy",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    mounted() {
        this.setupDragAndDrop();
    },
    beforeDestroy() {
        this.removeDragAndDrop();
    },
    async created() {
        this.columns.find((c) => c.field == "attachmentFileName").linkAction = (
            row,
        ) => {
            window.open(row.attachmentUrl);
        };

        this.loadCreditCardUsers();
    },
    watch: {
        async loadUsers(value) {
            //if (!value) return;

            const response = await this.$http.get(
                `/odata/users?$count=true&$filter=(contains(userName, '${
                    value ? value.trim() : ""
                }'))` + (!value ? "&$orderby=userName asc" : ""),
            );

            this.users = response.value.map((u) => u.userName);
        },
    },
    methods: {
        setupDragAndDrop() {
            const dropArea = this.$refs.dropArea;

            ["dragenter", "dragover", "dragleave", "drop"].forEach(
                (eventName) => {
                    dropArea.addEventListener(
                        eventName,
                        this.preventDefaults,
                        false,
                    );
                },
            );

            ["dragenter", "dragover"].forEach((eventName) => {
                dropArea.addEventListener(eventName, this.highlight, false);
            });

            ["dragleave", "drop"].forEach((eventName) => {
                dropArea.addEventListener(eventName, this.unhighlight, false);
            });

            ["click"].forEach((eventName) => {
                dropArea.addEventListener(eventName, this.pickFile, false);
            });

            dropArea.addEventListener("drop", this.handleDrop, false);

            const attachmentDropArea = this.$refs.attachmentDropArea;

            ["dragenter", "dragover", "dragleave", "drop"].forEach(
                (eventName) => {
                    attachmentDropArea.addEventListener(
                        eventName,
                        this.preventDefaults,
                        false,
                    );
                },
            );

            ["dragenter", "dragover"].forEach((eventName) => {
                attachmentDropArea.addEventListener(
                    eventName,
                    this.highlight,
                    false,
                );
            });

            ["dragleave", "drop"].forEach((eventName) => {
                attachmentDropArea.addEventListener(
                    eventName,
                    this.unhighlight,
                    false,
                );
            });

            ["click"].forEach((eventName) => {
                attachmentDropArea.addEventListener(
                    eventName,
                    this.pickAttachmentFile,
                    false,
                );
            });

            attachmentDropArea.addEventListener(
                "drop",
                this.handleAttachmentDrop,
                false,
            );
        },
        removeDragAndDrop() {
            const dropArea = this.$refs.dropArea;

            ["dragenter", "dragover", "dragleave", "drop"].forEach(
                (eventName) => {
                    dropArea.removeEventListener(
                        eventName,
                        this.preventDefaults,
                        false,
                    );
                },
            );

            ["dragenter", "dragover"].forEach((eventName) => {
                dropArea.removeEventListener(eventName, this.highlight, false);
            });

            ["dragleave", "drop"].forEach((eventName) => {
                dropArea.removeEventListener(
                    eventName,
                    this.unhighlight,
                    false,
                );
            });

            ["click"].forEach((eventName) => {
                dropArea.removeEventListener(eventName, this.pickFile, false);
            });

            dropArea.removeEventListener("drop", this.handleDrop, false);

            const attachmentDropArea = this.$refs.attachmentDropArea;

            ["dragenter", "dragover", "dragleave", "drop"].forEach(
                (eventName) => {
                    attachmentDropArea.removeEventListener(
                        eventName,
                        this.preventDefaults,
                        false,
                    );
                },
            );

            ["dragenter", "dragover"].forEach((eventName) => {
                attachmentDropArea.removeEventListener(
                    eventName,
                    this.highlight,
                    false,
                );
            });

            ["dragleave", "drop"].forEach((eventName) => {
                attachmentDropArea.removeEventListener(
                    eventName,
                    this.unhighlight,
                    false,
                );
            });

            ["click"].forEach((eventName) => {
                attachmentDropArea.removeEventListener(
                    eventName,
                    this.pickAttachmentFile,
                    false,
                );
            });

            attachmentDropArea.removeEventListener(
                "drop",
                this.handleAttachmentDrop,
                false,
            );
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        highlight(e) {
            e.target.classList.add("highlight");
        },
        unhighlight(e, dropArea) {
            e.target.classList.remove("highlight");
        },
        handleDrop(e) {
            const files = e.dataTransfer.files;

            if (!files) return;

            this.files = files;
        },
        async handleAttachmentDrop(e) {
            const files = e.dataTransfer.files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminportal/uploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                const uploadUrl = response.url;

                this.attachmentFiles.push(
                    Object.assign(files[0], { url: uploadUrl }),
                );

                console.log(this.attachmentFiles);

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async beforeSetupGrid() {
            if (this.isAdmin() || this.isCreditCardChargesAdmin()) {
                // this.actions.push({
                //     text: "Map To Users",
                //     action: this.openMapToUsersDialog,
                //     showOnSelection: true,
                // });

                this.actions.push({
                    text: "Delete",
                    action: this.openDeleteDialog,
                    showOnSelection: true,
                });

                this.actions.push({
                    text: "Credit Card Users",
                    action: this.openAddCreditUsersDialog,
                });

                this.actions.push({
                    text: "Import Charges",
                    action: this.openImportDialog,
                });
            }

            this.url =
                "creditCardCharges?user=" +
                (this.getUser() ? "" + this.getUser() : "");
        },
        async loadUnassignedUsers() {
            this.unassignedUsers = await this.$http.get(
                "api/creditCardCharges/getUnassignedUsers",
            );
        },
        getUser() {
            if (this.isAdmin() || this.isCreditCardChargesAdmin()) return null;

            return this.$store.state.authentication.user;
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        isCreditCardChargesAdmin() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Credit Card Charges Admin");
        },
        async loadCreditCardUsers() {
            const response = await this.$http.get(
                "api/creditCardCharges/getCreditCardUsers",
            );

            this.creditCardUsers = response.map((user) => {
                user.editing = false;
                user.selected = false;

                return user;
            });
        },
        openImportDialog() {
            this.importDialog = true;
        },
        openAddCreditUsersDialog() {
            this.creditCardUsersDialog = true;

            this.loadUnassignedUsers();
        },
        async openDeleteDialog() {
            const selected = this.$refs.grid.getSelectedRowsData();

            this.selectedCharges = selected.filter(
                (s) => s.status == "MISSING DESCRIPTION",
            );

            this.deleteCreditCardChargesDialog = true;
        },
        async openMapToUsersDialog() {
            this.selectedCharges = this.$refs.grid.getSelectedRowsData();

            const response = await this.$http.post(
                "api/creditCardCharges/getUsersForCharges",
                this.selectedCharges.map((s) => s.id),
            );

            this.chargesToMap = response.map((charge) => {
                charge.cardNumber = charge.cardNumber.substring(8, 16);

                return charge;
            });

            this.mapToUsersDialog = true;
        },
        truncateText(text, count = 25) {
            return truncate(text, count);
        },
        async deleteCharges() {
            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/creditCardCharges/deleteCreditCardCharges",
                    this.selectedCharges.map((c) => c.id),
                );

                this.deleteCreditCardChargesDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();

                this.$notify({
                    group: "notification",
                    text: response.deleted + " Charges Deleted",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async mapUsers() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/creditCardCharges/saveCreditCardChargeUsers",
                    this.chargesToMap,
                );

                this.mapToUsersDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();

                this.$notify({
                    group: "notification",
                    text: "Charges Mapped",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        pickFile() {
            this.$refs.files.click();
        },
        onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        pickAttachmentFile() {
            this.$refs.attachmentFiles.click();
        },
        // onAttachmentFilePicked(e) {
        //     this.uploading = true;

        //     const files = e.target.files;

        //     if (!files) return;

        //     this.attachmentFiles = files;

        //     this.uploading = false;
        // },
        closeImportDialog() {
            this.importDialog = false;
            this.files = [];
            this.$refs.files.value = "";
        },
        async importFile() {
            try {
                this.processing = true;

                var formData = new FormData();

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/CreditCardCharges/Import?user=" +
                        this.$store.state.authentication.user,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.$notify({
                    group: "notification",
                    text: response.saved + " Charges Saved",
                    type: "success",
                });

                this.processing = false;
                this.importDialog = false;
                this.files = [];
                this.$refs.files.value = "";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        closeUpdateChargeDialog() {
            this.creditCardChargeUpdateDialog = false;
            this.$refs.attachmentFiles.value = null;
            this.attachmentFiles = [];
        },
        async saveCharge() {
            try {
                this.processing = true;

                const data = JSON.parse(JSON.stringify(this.rowClicked));

                data.updatedBy = this.$store.state.authentication.user;

                await this.$http.post("api/creditCardCharges/save", {
                    creditCardCharge: data,
                    attachments: this.attachmentFiles.map((attachment) => ({
                        chargeID: data.id,
                        url: attachment.url,
                        fileName: attachment.name,
                        uploadedBy: this.$store.state.authentication.user,
                    })),
                });

                this.$notify({
                    group: "notification",
                    text: "Changes Deleted",
                    type: "success",
                });

                this.processing = false;
                this.creditCardChargeUpdateDialog = false;

                this.$refs.attachmentFiles.value = null;
                this.attachmentFiles = [];

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        async onRowClicked(row) {
            this.rowClicked = row;

            this.creditCardChargeUpdateDialog = true;

            this.loadCharge();

            //this.setupDragAndDrop();
        },
        async loadCharge() {
            const response = await this.$http.get(
                `api/creditCardCharges/getbyID?id=` + this.rowClicked.id,
            );

            this.rowClicked.attachments = response.attachments;

            this.$forceUpdate();
        },
        openUploadAttachmentDialog() {
            this.uploadAttachmentDialog = true;
        },
        async openAddCreditCardUser() {
            this.newCreditCardUser.username = [];

            const response = await this.$http.get(
                `/odata/users?$count=true&$orderby=userName asc`,
            );

            this.loadUsers = null;

            this.users = response.value.map((u) => u.userName);

            this.newCreditCardUser.firstName = "";
            this.newCreditCardUser.lastName = "";
            this.newCreditCardUser.unassignedUser = "";

            this.addCreditCardUserDialog = true;

            this.newCreditCardUser.unassignedUser = "";

            this.$forceUpdate();
        },
        onUserSelected(value) {
            if (!value) return;

            const parts = value.split(" ");

            this.newCreditCardUser.firstName = value ? parts[0] : "";
            this.newCreditCardUser.lastName = value ? parts[1] : "";
        },
        openDeleteCreditCardUsers() {
            this.deleteCreditCardUsersDialog = true;
        },
        async deleteUsers() {
            try {
                this.processing = true;

                const ids = this.creditCardUsers
                    .filter((c) => c.selected)
                    .map((s) => s.id);

                await this.$http.post(
                    "api/creditCardCharges/DeleteCreditCardUsers",
                    ids,
                );

                this.deleteCreditCardUsersDialog = false;
                this.loadCreditCardUsers();

                this.$notify({
                    group: "notification",
                    text: ids.length + " Users Deleted",
                    type: "success",
                });

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        disableEditing() {
            return this.creditCardUsers.some((c) => c.editing);
        },
        async editUser(user) {
            const response = await this.$http.get(
                `/odata/users?$count=true&$orderby=userName asc`,
            );

            this.loadUsers = null;
            this.users = response.value.map((u) => u.userName);
            user.usernameCopy = user.username.split(",");

            user.editing = true;
        },
        rollbackUser(user) {
            user.editing = false;

            this.loadCreditCardUsers();
        },
        async saveUser(user) {
            const selectedUsers = this.creditCardUsers.filter((u) => u.editing);

            const creditCardUser = selectedUsers.find((u) => u.id == user.id);

            const index = selectedUsers.indexOf(creditCardUser);

            if (
                !this.$refs.firstName[0].validate(true) ||
                !this.$refs.lastName[0].validate(true) ||
                !this.$refs.username[0].validate(true)
            )
                return;

            try {
                this.processing = true;

                user.updatedBy = this.$store.state.authentication.user;

                const data = JSON.parse(JSON.stringify(user));

                data.username = data.usernameCopy.join(",");

                await this.$http.post(
                    "api/creditCardCharges/saveCreditCardUser",
                    data,
                );

                this.processing = false;
                this.$refs.grid.reloadGrid();

                this.loadCreditCardUsers();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        async saveNewUser() {
            if (
                !this.$refs.newFirstName.validate(true) ||
                !this.$refs.newLastName.validate(true)
            )
                return;

            if (!this.newCreditCardUser.username.length) {
                return this.$notify({
                    text: "Please assign to a user",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                this.newCreditCardUser.enteredBy = this.$store.state.authentication.user;

                const data = JSON.parse(JSON.stringify(this.newCreditCardUser));

                data.username = data.username.join(",");

                await this.$http.post(
                    "api/creditCardCharges/saveCreditCardUser",
                    data,
                );

                this.processing = false;
                this.addCreditCardUserDialog = false;

                this.newCreditCardUser.firstName = "";
                this.newCreditCardUser.lastName = "";
                this.newCreditCardUser.username = [];
                this.newCreditCardUser.unassignedUser = "";

                this.$refs.grid.reloadGrid();

                this.loadCreditCardUsers();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        getAttachmentText() {
            if (!this.rowClicked.attachments) return "";

            return (
                this.rowClicked.attachments.length +
                " " +
                pluralize("Attachment", this.rowClicked.attachments.length)
            );
        },
        downloadAttachment(attachment) {
            window.open(attachment.url);
        },
        openDeleteAttachment(attachment) {
            this.attachmentToDelete = attachment;
            this.deleteAttachmentDialog = true;
        },
        async deleteAttachment() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/creditCardCharges/deleteAttachment?id=" +
                        this.attachmentToDelete.id,
                );

                this.processing = false;
                this.deleteAttachmentDialog = false;
                this.loadCharge();

                this.$refs.grid.reloadGrid();

                this.$notify({
                    group: "notification",
                    text: "Attachment Deleted",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        pickFile(isNew = false) {
            this.$refs.files.click();
        },
        async onAttachmentFilePicked(e, isNew = false) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminportal/uploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                const uploadUrl = response.url;

                this.attachmentFiles.push(
                    Object.assign(files[0], { url: uploadUrl }),
                );

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        cancelAttachment(attachment) {
            this.$refs.attachmentFiles.value = null;

            const index = this.attachmentFiles.indexOf(attachment);

            this.attachmentFiles.splice(index, 1);

            this.uploadUrl = "";
        },
        closeUploadAttachmentDialog() {
            this.uploadAttachmentDialog = false;
            this.$refs.attachmentFiles.value = null;
            this.attachmentFiles = [];
            this.uploadUrl = "";
        },
        async saveFile() {
            try {
                this.processing = true;

                await this.$http.post("api/creditCardCharges/saveAttachment", {
                    chargeID: this.rowClicked.id,
                    url: this.uploadUrl,
                    fileName: this.attachmentFiles[0].name,
                    uploadedBy: this.$store.state.authentication.user,
                });

                this.processing = false;
                this.closeUploadAttachmentDialog();
                this.loadCharge();
                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.accounts-search.container {
    padding-top: 0px;
}
.yg-student-account-match {
    border: 2px solid #4caf50;
}
.dropArea {
    border: 2px dashed #ccc;
    width: 100%;
    height: 150px;
    text-align: center;
    padding: 20px;
    cursor: pointer;
}
.highlight {
    border-color: #fc0;
}
</style>
